import { View } from '../actions'
import { OnboardingScreen, type OnboardingProperties } from '../objects/OnboardingScreen'
import { analytics } from './lib'

export const OnboardingScreenView = (params: OnboardingProperties) =>
  analytics(new View(), new OnboardingScreen(params))
